module.exports = __webpack_public_path__ + "img/aeroland-ebook-box-image-01.8835f1a4.png";